"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostMeasurementDataFromJSON = PostMeasurementDataFromJSON;
exports.PostMeasurementDataFromJSONTyped = PostMeasurementDataFromJSONTyped;
exports.PostMeasurementDataToJSON = PostMeasurementDataToJSON;
exports.PostMeasurementDataToJSONTyped = PostMeasurementDataToJSONTyped;
function PostMeasurementDataFromJSON(json) {
    return PostMeasurementDataFromJSONTyped(json, false);
}
function PostMeasurementDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'eventName': json['eventName'],
        'value': json['value'],
    };
}
function PostMeasurementDataToJSON(value) {
    return PostMeasurementDataToJSONTyped(value, false);
}
function PostMeasurementDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'eventName': value.eventName,
        'value': value.value,
    };
}
